import { ref, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { resolveDeadlineVariant } from '@/views/financial/payment-remittance-list/usePaymentRemittanceList'
import { downloadBlob, maskCnpj } from '@core/utils/utils'
import {
  format, subDays, parse, startOfDay, subHours,
} from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

export default function useReportLaunchedVsConfirmed() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)
  // Table Handlers
  const tableColumns = [
    {
      key: 'institution.name', label: 'Instituição', sortKey: 'institution.name', sortable: true,
    },
    {
      key: 'workplace.name', label: 'Unidade', sortKey: 'workplace.name', sortable: true,
    },
    {
      key: 'launched_count', label: 'Qtd. Lançado', sortKey: 'launched_count', sortable: true,
    },
    {
      key: 'confirmed_count', label: 'Qtd. Confirmado', sortKey: 'confirmed_count', sortable: true,
    },
    { key: 'ratio', label: '%', sortable: true },
  ]
  const perPage = ref(25)
  const totalItems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const isSortDirDesc = ref(true)
  const myList = ref([])
  const institutionId = ref(null)
  const start = subHours(startOfDay(subDays(new Date(), 1)), 0)
  const startDate = ref(format(start, 'dd/MM/yyyy HH:mm', { locale: ptBR }))
  const endDate = ref(format(new Date(), 'dd/MM/yyyy HH:mm', { locale: ptBR }))
  const institutionOptions = ref([])
  const showImediato = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    }
  })

  const getDate = date => format(parse(date, 'dd/MM/yyyy HH:mm', new Date(), { locale: ptBR }), 'yyyy-MM-dd HH:mm:ss')

  const getParams = () => ({
    show_imediato: showImediato.value ? '1' : '0',
    start_date: getDate(startDate.value) || undefined,
    end_date: getDate(endDate.value) || undefined,
    institution: institutionId.value ? institutionId.value.value : undefined,
  })

  const getItems = () => {
    store
      .dispatch('app-reports/launchedVsConfirmed', getParams())
      .then(response => {
        myList.value = response.data.data
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao listar',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const createPaymentRemittance = async paymentDate => {
    const items = myList.value.filter(contract => contract.checked).map(contract => ({ contract_id: contract.id, operation: null }))
    try {
      const { data } = await store
        .dispatch('app-reports/createPaymentRemittance', {
          items,
          payment_date: paymentDate,
        })
      return {
        id: data.data.id,
        code: data.data.code,
      }
    } catch (err) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
    return null
  }

  const fetchInstitutions = () => {
    store.dispatch('app-reports/fetchInstitutions', { perPage: 99999999 })
      .then(response => {
        institutionOptions.value = response.data.data.map(inst => ({
          value: inst.id,
          label: `${inst.name} | ${maskCnpj(inst.cnpj)}`,
        }))
      })
  }

  const exporting = ref(false)
  const downloadReport = () => {
    exporting.value = true
    store.dispatch('app-reports/launchedVsConfirmedExport', getParams())
      .then(response => {
        downloadBlob(null, response)
      })
      .finally(() => {
        exporting.value = false
      })
  }

  const refetchData = () => {
    getItems()
  }

  return {
    downloadReport,
    exporting,
    myList,
    getItems,
    tableColumns,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    isSortDirDesc,
    startDate,
    endDate,
    refUserListTable,
    refetchData,
    showImediato,
    fetchInstitutions,
    institutionId,
    institutionOptions,
    createPaymentRemittance,
    resolveDeadlineVariant,
  }
}
